module.exports = __webpack_public_path__ + "img/type--1-spans--multiple-lang--de.7d28d8c9.jpg";